import React from "react";

export default function SmallBusinessBuilt({data}) {
  
  return (
    <>
      <section className="smart-built-area">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="smart-built-header">
                <h3 className="heading center-heading">{data?.head}</h3>
                <p className="sub-heading">{data?.desc}</p>
              </div>
            </div>

            {data && data?.boxes?.map((item, index) => (
              <div key={index} className="col-lg-3 col-md-6">
                <div className="smart-built-card">
                  <img src={item?.img} alt="small-built-icon" />
                  <span>{item?.title}</span>
                  <p>{item?.desc}</p>
                </div>
              </div>
            ))}

          </div>
        </div>
      </section>
    </>
  )
}

